var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTogglePlus = function SvgTogglePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141515",
    fillRule: "evenodd",
    d: "M6.515 15.05h2V8.534h6.534v-2H8.515V0h-2v6.534H0v2h6.515v6.515Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M15.05 18.416v2H0v-2h15.05Z"
  })));
};
export { SvgTogglePlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMSIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzE0MTUxNSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41MTUgMTUuMDVoMlY4LjUzNGg2LjUzNHYtMkg4LjUxNVYwaC0ydjYuNTM0SDB2Mmg2LjUxNXY2LjUxNVoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtb3BhY2l0eT0iLjMiIGQ9Ik0xNS4wNSAxOC40MTZ2Mkgwdi0yaDE1LjA1WiIvPjwvc3ZnPgo=";